'use client';

import { usePermissions } from '@/hooks';

/**
 * Custom hook for checking permissions
 */
const useHasPermission = (allowed = []) => {
  const userPermissions = usePermissions();
  if (!userPermissions?.length) return false;

  const normalized = userPermissions.map((p) =>
    typeof p === 'string' ? p : `${p.resource}.${p.action}`
  );

  return allowed.some((perm) => {
    if (perm === '*') return true; // global allow

    const [res, act] = perm.split('.');

    // exact match
    if (normalized.includes(perm)) return true;

    // allowed has wildcard e.g. subscription.*
    if (act === '*') {
      return normalized.some((up) => {
        const [upRes, upAct] = up.split('.');
        return upRes === res && upAct === '*'; // must also be wildcard, not just any action
      });
    }

    // user has wildcard e.g. subscription.*
    return normalized.some((up) => {
      const [upRes, upAct] = up.split('.');
      return upRes === res && upAct === '*';
    });
  });
};
/**
 * Permission wrapper
 */
export const PermissionWrapper = ({ allowed = [], children, fallback = null }) => {
  const isAccess = useHasPermission(allowed);

  if (!isAccess) {
    return fallback ?? null;
  }

  return <>{children}</>;
};
